import {
    CourseDTO,
    CourseTranslationDTO,
    CourseFlatDTO,
} from "../domain/models/dto/CourseDTO";
import { BaseModelImpl } from "./BaseModelImpl";
import { ICourse } from "../domain/models/Course";

export class CourseModel extends BaseModelImpl<ICourse> {
    id?: string;
    imageUrl?: string;
    files?: any[];
    translations?: CourseTranslationDTO[];
    availableLangs?: string[];
    creatorId?: string;
    createdAt?: Date;
    updatedAt?: Date;
    updatorId?: string;

    constructor(data?: ICourse | CourseDTO) {
        super();
        if (data) {
            Object.assign(this, data);
        }
    }

    get title(): string {
        return this.translations?.[0]?.title || "";
    }

    get description(): string {
        return this.translations?.[0]?.description || "";
    }

    get shortContent(): string {
        return this.translations?.[0]?.shortContent || "";
    }

    get author(): string {
        return this.translations?.[0]?.author || "";
    }

    get duration(): string {
        return this.translations?.[0]?.duration || "";
    }

    get topic(): string {
        return this.translations?.[0]?.topic || "";
    }

    static fromDTO(dto: CourseDTO): CourseModel {
        return new CourseModel(dto);
    }

    toDTO(): CourseDTO {
        return {
            id: this.id,
            imageUrl: this.imageUrl,
            files: this.files,
            translations: this.translations,
            availableLangs: this.availableLangs,
            creatorId: this.creatorId,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            updatorId: this.updatorId,
        };
    }
}
